module.exports = __webpack_public_path__ + "assets/img/camera.bb61e46f.png";